import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() url: string;
  @Input() classList: string;

  constructor(
    private _router: Router
  ) { }

  /**
   * Function to navigate
   * @param url URL to go
   */
  goTo(url: string): void {
    this._router.navigate([url]);
  }

}
